import { render, staticRenderFns } from "./policyImportModal.vue?vue&type=template&id=edc458a0&scoped=true"
import script from "./policyImportModal.vue?vue&type=script&lang=js"
export * from "./policyImportModal.vue?vue&type=script&lang=js"
import style0 from "./policyImportModal.vue?vue&type=style&index=0&id=edc458a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc458a0",
  null
  
)

export default component.exports